<template>
  <div>
    <offers-form :route="route" @on-submit="onOfferSubmit"></offers-form>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import OffersForm from './OffersForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      OffersForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        offerModel: {},
        offer: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onOfferSubmit (model, isValid) {
        this.offerModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/OffersAdd.vue